import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL } from '../data/product';
const included = ['6 volumes · 52 weekly sessions', 'Run Sheet + Drill Cards for every session', 'Every drill at 3 levels (new / developing / advanced)', 'A worksheet + pocket Field Card per session', '5 bonuses, incl. the 20-Minute Practice Picker', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cloud text-ink" data-id="element-202" data-mp="1rujb018j9qwe">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-203" data-mp="25q4ujsvzzihf">
        <div className="text-center" data-id="element-204" data-mp="20s3ap5qqzf4w">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-coral-deep" data-id="element-205" data-mp="20v7psy5r3vac">Complete package</p>
          <h2 id="pricing-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-206" data-mp="3c8a5zs3xuitz">
            Your whole year of practices, planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-cloud-dark bg-white shadow-soft" data-id="element-207" data-mp="3w1t7hufwuz6n">
          <div className="bg-ink px-5 py-5 text-center" data-id="element-208" data-mp="4uys0rkgls61">
            <h3 className="font-display text-lg font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-209" data-mp="9tjt0t7jcfvj">52 Weeks of Volleyball Practice Plans — Complete Package</h3>
            <p className="mt-1 text-[13px] font-semibold uppercase tracking-widest text-amber" data-id="element-210" data-mp="3d9h7hecqc9zo">6 Volumes + 5 Bonuses</p>
          </div>
          <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-211" data-mp="3i8tqtp4e6yxi" />

          <div className="p-5 sm:p-7" data-id="element-212" data-mp="3n6v9i8xwow8g">
            <div id="offer" className="scroll-mt-4 rounded-2xl bg-cloud px-[8%] py-8" data-id="element-213" data-mp="3n5txa155m3p5">
              <ProductVisual lazy className="w-full" data-id="element-214" data-mp="3rzeo998bxxeu" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-215" data-mp="2uhenpu4skdl7">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-216" data-mp="2zgixalvmodc2">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-teal" data-id="element-217" data-mp="2rg35g6jtu4p1">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-218" data-mp="2mh8o791ico71" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cloud-dark pt-6 text-center" data-id="element-219" data-mp="2w8min2elqxtb">
              <p className="text-[13px] text-slate" data-id="element-220" data-mp="28hh5iv01qjmp">
                Total value <span className="line-through" data-id="element-221" data-mp="28jtsxnokpm75">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-ink" data-id="element-222" data-mp="23kqlxxp195wj">
                <span className="mt-2.5 font-display text-3xl font-extrabold" data-id="element-223" data-mp="2ihrh6b6fnizr">$</span>
                <span className="font-display text-[56px] font-extrabold leading-[0.9] sm:text-7xl" data-id="element-224" data-mp="2dg21ujc6gj5v">27</span>
                <span className="mt-3 text-[13px] font-semibold text-slate" data-id="element-225" data-mp="3tu0l5omw6otv">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-226" data-mp="3ovqplcx99m7q">
                <span className="rounded-full bg-amber px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-227" data-mp="a41llomekma">Save $70</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-228" data-mp="57dqn083ku9l">One-time payment</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-229" data-mp="3rhgbrgr35xsp">No app, no subscription</span>
              </div>

              <p className="mt-4 text-[13px] text-slate" data-id="element-230" data-mp="nywv7bhrsgdq">That&apos;s about 52 cents a session.</p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-231" data-mp="a7i6co16lkyr">
                Get the Practice Plans — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-slate" data-id="element-232" data-mp="e7sdw54mgjfq">Backed by the 7-day money-back guarantee</p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-slate" data-id="element-233" data-mp="11xmt2tceyk35">
                <li className="flex items-center gap-1.5" data-id="element-234" data-mp="3f7im4c92e4q5">
                  <LockIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-235" data-mp="3f93djt0317js" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-236" data-mp="359cldxyzv4mv">
                  <ZapIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-237" data-mp="359un3a4feb26" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-238" data-mp="1sm6supcjj9k">
                  <ShieldCheckIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-239" data-mp="1s4177gsnsoz" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-slate" data-id="element-240" data-mp="3o6dnnb15yqn4">Price in USD. You&apos;ll be charged the equivalent in your local currency.</p>
      </div>
    </section>;
}